// Module
var code = "<button class=\"search-result-card__button\"> <span class=\"search-result-card__text\"></span> </button>";
// Exports
export default code;